import { chakra, forwardRef, Textarea, TextareaProps } from '@chakra-ui/react'

const TextArea = forwardRef((props: TextareaProps, ref) => {
  const { isDisabled } = props
  return (
    <Textarea
      fontWeight={'normal'}
      _hover={isDisabled ? {} : { borderColor: 'primary.300' }}
      _focusVisible={isDisabled ? {} : { borderWidth: '1.5px', borderColor: 'primary.600' }}
      borderRadius='4'
      bg={isDisabled ? '#EBECEC' : ''}
      color={'#000'}
      _placeholder={
        isDisabled ? { color: '#000', alignContent: 'center' } : { alignContent: 'center' }
      }
      resize={'vertical'}
      ref={ref}
      size='md'
      rows={1}
      minHeight={'40px'}
      {...props}
    ></Textarea>
  )
})

export { TextArea }
